module.exports = __webpack_public_path__ + "img/machine-learning.f6e216d0.png";